import { useState } from "react";
import { FileUp, Link2, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import axios, { API } from "@/lib/apiClient";
import { toast } from "sonner";

export const TruthVerifyPanel = ({ auditId }) => {
  const [url, setUrl] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async () => {
    if (!url && !file) return;
    setLoading(true);
    try {
      const form = new FormData();
      if (file) form.append("file", file);
      else form.append("url", url);
      const { data } = await axios.post(`${API}/audits/${auditId}/truth-verify`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setResult(data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Verification failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rounded-lg border border-truth-green/30 bg-surface-card p-6" data-testid="truth-verify-panel">
      <h3 className="mb-1 font-heading text-lg font-bold text-white">Verify with Truth</h3>
      <p className="mb-4 text-sm text-slate-400">Upload your ground-truth URL or PDF and we'll audit AI claims against it.</p>
      <div className="mb-3 flex items-center gap-2">
        <Link2 className="h-4 w-4 text-slate-500" />
        <input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://yourbrand.com/about"
          disabled={!!file}
          className="flex-1 rounded-md border border-surface-border bg-obsidian px-3 py-2 text-sm text-white outline-none focus:border-truth-green disabled:opacity-40"
          data-testid="truth-verify-url-input"
        />
      </div>
      <div className="mb-4 flex items-center gap-2">
        <FileUp className="h-4 w-4 text-slate-500" />
        <input
          type="file"
          accept="application/pdf"
          onChange={(e) => setFile(e.target.files?.[0] || null)}
          className="flex-1 text-sm text-slate-400"
          data-testid="truth-verify-file-input"
        />
      </div>
      <Button onClick={submit} disabled={loading} className="gap-2 bg-truth-green text-obsidian hover:bg-truth-green/90" data-testid="truth-verify-submit-btn">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Run Verification"}
      </Button>

      {result && (
        <div className="mt-6 space-y-3" data-testid="truth-verify-results">
          <p className="text-sm text-slate-300">
            Accuracy Score: <span className="font-bold text-truth-green">{result.accuracy_score}/100</span>
          </p>
          <p className="text-sm text-slate-400">{result.summary}</p>
          {(result.discrepancies || []).map((d, i) => (
            <div key={i} className="rounded-md border border-sovereign/30 bg-sovereign/5 p-3" data-testid={`truth-discrepancy-${i}`}>
              <p className="text-sm font-semibold text-sovereign">AI claimed: {d.ai_claim}</p>
              <p className="text-sm text-slate-300">Ground truth: {d.ground_truth}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
